import { render, staticRenderFns } from "./EditAnnouncement.vue?vue&type=template&id=40b9445c&scoped=true&"
import script from "./EditAnnouncement.vue?vue&type=script&lang=js&"
export * from "./EditAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./EditAnnouncement.vue?vue&type=style&index=0&id=40b9445c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b9445c",
  null
  
)

export default component.exports